import { render, staticRenderFns } from "./FillForm20.vue?vue&type=template&id=ba0c6622&scoped=true"
import script from "./FillForm20.vue?vue&type=script&lang=ts"
export * from "./FillForm20.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0c6622",
  null
  
)

export default component.exports